import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    name = '',
    kpiId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.create, {
        name,
        kpiId,
    }, options);
    if (error) return { error, status };
    return content || {};
};

